import { useEffect, useState } from 'react'

export default function useContainerMutate<T extends HTMLElement>(callback: () => void) {
  const [container, setContainer] = useState<T | null>(null)

  useEffect(() => {
    if (!container) return

    function handleMutation() {
      callback()
    }

    const mo = new MutationObserver(handleMutation)
    mo.observe(container, { childList: true, subtree: true })
    return () => {
      mo.disconnect()
    }
  }, [callback, container])

  return { target: (target: T) => setContainer(target) }
}
